module.exports = __webpack_public_path__ + "static/images/HSBC_MASTERBRAND_LOGO_RGB_NEG.8d3f5e3.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/HSBC_MASTERBRAND_LOGO_RGB_NEG.png
// module id = uzBt
// module chunks = 0 1 2